/**
 * NewsList
 */
import React from 'react';
import clsx from 'clsx';
/** Main description for this component. */
var NewsList = function (_a) {
    var className = _a.className, children = _a.children;
    return (React.createElement("div", { "aria-live": "polite", className: clsx(className, 'border-t-borderWidth border-borderColor pt-4'), "data-cid": "NewsList" }, children));
};
export default NewsList;
